import { ErrorTechnicalDetails } from '@/components/Errors/ErrorTechnicalDetails';

const CARD_SIZES = {
  compact: 'p-8 max-w-[500px]',
  wide: 'p-12 w-[90%] max-w-[700px]',
} as const;

export const ErrorScreen: React.FC<{
  title: string;
  message: string;
  error?: unknown;
  componentStack?: string | null;
  size?: keyof typeof CARD_SIZES;
  children?: React.ReactNode;
}> = ({ title, message, error, componentStack, size = 'compact', children }) => (
  <div className="min-h-screen flex justify-center items-center bg-background p-8">
    <div className={`bg-card border border-border rounded-xl shadow-lg ${CARD_SIZES[size]}`}>
      <h2 className="text-destructive mb-4 text-xl font-semibold">{title}</h2>
      <p className="text-muted-foreground mb-4">{message}</p>
      {error !== undefined && error !== null && (
        <ErrorTechnicalDetails error={error} componentStack={componentStack} className="mb-4" />
      )}
      {children}
    </div>
  </div>
);
